(() => {
  const translations = new Map([
    ['Products', 'Produkter'],
    ['All products', 'Produkter'],
    ['Availability', 'Tilgjengelighet'],
    ['Price', 'Pris'],
    ['Filter:', 'Filter:'],
    ['Sort by:', 'Sorter etter:'],
    ['Filter and sort', 'Filtrer og sorter'],
    ['Filter', 'Filtrer'],
    ['Sort', 'Sorter'],
    ['Alphabetically, A-Z', 'Alfabetisk, A–Å'],
    ['Alphabetically, Z-A', 'Alfabetisk, Å–A'],
    ['Price, low to high', 'Pris, lav til høy'],
    ['Price, high to low', 'Pris, høy til lav'],
    ['Date, old to new', 'Dato, eldste først'],
    ['Date, new to old', 'Dato, nyeste først'],
    ['Best selling', 'Mest solgte'],
    ['Featured', 'Utvalgt'],
    ['Most relevant', 'Mest relevant'],
    ['In stock', 'På lager'],
    ['Out of stock', 'Utsolgt'],
    ['Clear all', 'Fjern alle'],
    ['Remove all', 'Fjern alle'],
    ['Reset', 'Tilbakestill'],
    ['Apply', 'Bruk'],
    ['Add', 'Bruk'],
    ['Search', 'Søk'],
    ['Search results', 'Søkeresultater'],
    ['No results found', 'Ingen resultater funnet'],
    ['No products found', 'Ingen produkter funnet'],
    ['Use fewer filters or remove all', 'Bruk færre filtre eller fjern alle'],
    ['View all', 'Vis alle'],
    ['View details', 'Vis alle detaljer'],
    ['Clear', 'Fjern'],
    ['Remove', 'Fjern'],
    ['From', 'Fra'],
    ['To', 'Til'],
    ['Check out', 'Kasse'],
    ['Checkout', 'Kasse'],
    ['View cart', 'Vis handlekurv'],
    ['Continue shopping', 'Fortsett å handle'],
    ['Item added to your cart', 'Vare lagt i handlekurven'],
  ]);

  const dynamicTranslations = [
    [/^(\d+) selected$/, '$1 valgt'],
    [/^(\d+) products$/, '$1 produkter'],
    [/^(\d+) of (\d+) products$/, '$1 av $2 produkter'],
    [/^The highest price is (.+)$/, 'Høyeste pris er $1'],
  ];

  const translateText = (element) => {
    if (!element || element.children.length > 0) return;
    const current = element.textContent.trim();
    if (!current) return;
    const direct = translations.get(current);
    if (direct && direct !== current) {
      element.textContent = direct;
      return;
    }
    for (const [pattern, replacement] of dynamicTranslations) {
      if (pattern.test(current)) {
        element.textContent = current.replace(pattern, replacement);
        return;
      }
    }
  };

  const selectors = [
    '.collection-hero__title',
    '.facets__heading',
    '.facet-filters__label label',
    '.mobile-facets__heading',
    '.mobile-facets__sort label',
    '.facets__summary span',
    '.mobile-facets__summary span',
    '.facets__selected',
    '.facets__price .field__label',
    '.mobile-facets__label',
    '.mobile-facets__count',
    '.product-count__text',
    '.facets__form label',
    'select[name="sort_by"] option',
    '.cart-notification__heading',
    '.cart-notification__links a',
    '.cart-notification__links button',
    '.predictive-search__heading',
    '.template-search__header h1',
  ].join(',');

  const localize = (root = document) => {
    root.querySelectorAll(selectors).forEach(translateText);
  };

  const run = () => localize(document);
  document.addEventListener('DOMContentLoaded', run, { once: true });
  document.addEventListener('shopify:section:load', run);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length || mutation.type === 'characterData')) {
      localize(document);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }, { once: true });
})();
